export default "__VITE_ASSET__vcdIwjDn__"